import { Skeleton } from '@app/components/various/Skeleton';
import { getProductListingAttributes, getProductsGridSize } from '@app/ducks';
import { getDefaultImageAspectRatio } from '@app/ducks/helpers';
import { isEmpty } from '@app/utils/isEmpty';
import { useSelector } from 'react-redux';

const MAX_NUMBER_OF_ATTRIBUTES = 3;

interface Props {
  size?: 'small' | 'medium' | 'large';
}

export const ProductCardSkeleton = ({ size }: Props) => {
  const imageAspectRatio = useSelector(getDefaultImageAspectRatio);
  const listingAttributes = useSelector(getProductListingAttributes);
  const fallbackSize = useSelector(getProductsGridSize);

  const productsGridSize = size ?? fallbackSize;
  const hasListingAttributes = !isEmpty(listingAttributes);
  const attributesCount = Math.min(listingAttributes.length, MAX_NUMBER_OF_ATTRIBUTES);

  if (productsGridSize === 'large') {
    return (
      <div key={productsGridSize}>
        <Skeleton type="rectangle" aspectRatio={imageAspectRatio} className="mb-5" />
        <Skeleton type="text" rows={2} size="large" gap="medium" lastWidth={60} containerClassName="mb-3" />
        {hasListingAttributes && <Skeleton type="text" rows={attributesCount} size="small" gap="medium" lastWidth={60} />}
      </div>
    );
  }

  if (productsGridSize === 'medium') {
    return (
      <div key={productsGridSize}>
        <Skeleton type="rectangle" aspectRatio={imageAspectRatio} className="mb-3" />
        <Skeleton type="text" rows={2} size="large" gap="medium" lastWidth={60} containerClassName="mb-3" />
        {hasListingAttributes && <Skeleton type="text" rows={attributesCount} size="small" gap="medium" lastWidth={60} />}
      </div>
    );
  }

  return (
    <div>
      <Skeleton type="rectangle" aspectRatio={imageAspectRatio} />
    </div>
  );
};
